import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class SaleTypes {
  static list: IActionType = new ActionType('SALE/LIST');
  static export: IActionType = new ActionType('SALE/EXPORT');
  static oldFilters: IActionType = new ActionType('SALE/OLD_FILTERS');
  static backgroundReport: IActionType = new ActionType('SALE/BACKGROUND_EXPORT');
  static backgroundReportSales: IActionType = new ActionType('SALE/BACKGROUND_EXPORT_SALES');
}

export default SaleTypes;
